export default __webpack_public_path__ + "static/media/image_llave.760531f8.png";